// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import {Button, Group, Space, Text} from '@mantine/core';
import React, { FC } from 'react';
import { ConstantS } from '../../Service/ConstantS';
import {MixpanelS} from "../../Service/MixpanelS";

interface Props {
  onFinish: () => void;
  closeModal: () => void;

}

const SkipOnboardingModal: FC<Props> = ({ onFinish, closeModal }) => {

  return (
    <>
      <Text mt="md" weight="bolder" size={24} align="center" sx={{ lineHeight: 1.2 }}>
        ❌ {`Achtung: Du verlierst Zeit!` } ❌
      </Text>
      <Space h="sm" />
      <Text mb="xs" color="dimmed" align="center">
        {`Unser Job ist es, Dir Zeit zu sparen.` }
      </Text>
      <Space h="sm" />
      <Group mt="xs" mb="xs" position="center">
        <Text mb="sm" align="center">
          {/*{`Im Onboarding geben wir Dir einen persönlichen Schnelleinstieg in bookitup.` }*/}
          {`Nach der Demo wirst Du` }
          <Text weight="bolder">
            {`ca. 40 Stunden pro Monat sparen.` }
          </Text>
        </Text>
      </Group>
      <Group mt="xs" mb="xs" position="center">
        <Button color={"red"} fullWidth sx={{ maxWidth: 250, color: "white" }} onClick={() => {
          MixpanelS.track(ConstantS.TrackingEvents.SkipOnboarding);
          onFinish();
        }}>
          Ohne Demo zur Software
        </Button>
        <Button fullWidth sx={{ maxWidth: 270 }} onClick={() => {
          closeModal();
        }}>
          Demo vereinbaren und zur Software
        </Button>
        <Text mb="xs" color="dimmed" align="center" sx={{ maxWidth: 400 }}>
          {`Nach der Terminbuchung kommst du direkt zur App und kannst den Termin auch jederzeit wieder stornieren.` }

        </Text>

      </Group>
    </>

  );
};

export default SkipOnboardingModal;
